import React from "react";

import { IconErrorOutlined } from "~/components/icon";

import {
	DrawerComponentTitle,
	DrawerTitle as ExplorationDrawerTitle,
} from "../../../../components/react/drawer/ExplorationDrawer";
import { queryFullComponent } from "../../../../queries";
import { useQuery } from "../../../../queries/react-query";

import type { RelatedResourcesDrawerState } from "./state";

type DrawerTitleProps = Pick<RelatedResourcesDrawerState, "timestamp" | "componentIdOrIdentifier">;

export const DrawerTitle: React.FC<DrawerTitleProps> = ({ timestamp, componentIdOrIdentifier }) => {
	const { error, data: fullComponent } = useQuery({
		refetchOnMount: false,
		refetchOnReconnect: false,
		refetchOnWindowFocus: false,

		...queryFullComponent({ timestamp, componentIdOrIdentifier }),
	});

	if (error != null) {
		return (
			<ExplorationDrawerTitle
				icon={<IconErrorOutlined className="text-red-500" height={20} width={20} />}
				title="Error while loading related resources"
			/>
		);
	}

	if (fullComponent == null) {
		return <ExplorationDrawerTitle title={undefined} />;
	}

	return <DrawerComponentTitle component={fullComponent} displayTypeName typeOfData="Related resources" />;
};
